import React, { memo } from "react";
import { Link } from "react-router-dom";
import { EN_PREFIX } from "@/utils/locale";
import { FooterBrand, FooterContact, FooterCopyright } from "./FooterShared";
import "./footerEn.less";

const FOOTER_COPY = {
  qrTitle: "QR",
  qr1: "Trusme Official Account",
  qr2: "Wayforcloud Official Account",
  contactTitle: "Contact Us",
  mainLine: "Tel",
  afterSales: "After-sales Department",
  fax: "Fax",
  WhatsApp: "WhatsApp",
  copyright: "Copyright © 2026 Trusme |",
  icp: "Guangdong ICP No. 10023868 |",
  psb: "Guangdong Public Security Network No. 44011602000125",
};

/** 与 NewNav enNavItemDefs 保持一致 */
const EN_FOOTER_NAV = [
  { key: "home", category: "Home", path: EN_PREFIX },
  { key: "solution", category: "Solutions", path: `${EN_PREFIX}/solution` },
  { key: "services", category: "Services", path: `${EN_PREFIX}/services` },
  { key: "about", category: "About Us", path: `${EN_PREFIX}/about` },
];

const FooterEnNav = () => (
  <nav className="footer-en__nav" aria-label="Footer navigation">
    <ul className="footer-en__nav-list">
      {EN_FOOTER_NAV.map((item) => (
        <li key={item.key} className="footer-en__nav-item">
          <Link to={item.path} className="footer-en__nav-link">
            {item.category}
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);

const FooterEn = ({ contactInfo, homePath }) => (
  <footer className="global-footer global-footer--en light-theme">
    <div className="footer-en themesCube middle">
      <div className="footer-en__main">
        <FooterBrand
          homePath={homePath}
          qr1={FOOTER_COPY.qr1}
          qr2={FOOTER_COPY.qr2}
        />
        <FooterEnNav />
        <FooterContact copy={FOOTER_COPY} contactInfo={contactInfo} />
      </div>
      <FooterCopyright copy={FOOTER_COPY} />
    </div>
  </footer>
);

export default memo(FooterEn);
